/* eslint-disable sort-keys */
const translations = {
  Cart: "Cart",
  Color: "Colour",
  Colorful: "Colourful",
  Customize: "Customize",
  Dollar: "Dollar",
  Gray: "Grey",
  Honor: "Honour",
  Instalment: "Instalment",
  JEWELRY: "JEWELLERY",
  Jewelry: "Jewellery",
  Labor: "Labour",
  Mom: "Mom",
  Moms: "Moms",
  Personalization: "Personalization",
  Personalize: "Personalize",
  Personalized: "Personalized",
  Personalized_Jewelry: "Personalized Jewellery",
  Personalizing: "Personalizing",
  Shipping: "Shipping",
  Symbolize: "Symbolize",
  Vermeil: "Vermeil",
  WatchBandColor: "Watch Band Colour",
  WatchCaseColor: "Watch Case Colour",
  authorize: "authorize",
  business: "business",
  cart: "cart",
  center: "centre",
  collections: {
    Color: "Colour",
    Jewelry: "Jewellery",
    Personalized: "Personalized",
    Personalized_Jewelry: "Personalized Jewellery",
    Personalized_jewelry: "Personalized jewellery",
    color: "colour",
    jewelry: "jewellery",
    mom: "mom",
    personalized: "personalized",
  },
  color: "colour",
  colorful: "colourful",
  customization: "customization",
  customize: "customize",
  customizable: "customizable",
  dollar: "dollar",
  favorite: "favourite",
  Favorite: "Favourite",
  gray: "grey",
  honor: "honour",
  instalment: "instalment",
  itemize: "itemize",
  Itemize: "Itemize",
  itemized: "itemized",
  Itemized: "Itemized",
  jeweler: "jeweller",
  jewelry: "jewellery",
  labor: "labour",
  mom: "mom",
  moms: "moms",
  mommy: "mommy",
  Mommy: "Mommy",
  neighbor: "neighbour",
  neighboring: "neighbouring",
  organization: "organization",
  personalizable: "personalizable",
  personalization: "personalization",
  personalize: "personalize",
  personalized: "personalized",
  personalized_jewelry: "personalized jewellery",
  personalizing: "personalizing",
  recognized: "recognized",
  ship: "ship",
  shipping: "shipping",
  ships: "ships",
  specialize: "specialize",
  symbolize: "symbolize",
  tenK: "10K",
  tenk: "10k",
  "number.currency.name": "dollar",
  "number.currency.code": "CAD",
  "number.currency.format.delimiter": ",",
  "number.currency.format.format": "%u%n",
  "number.currency.format.precision": 2,
  "number.currency.format.separator": ".",
  "number.currency.format.significant": false,
  "number.currency.format.strip_insignificant_zeros": false,
  "number.currency.format.unit": "$",
  "number.format.delimiter": ",",
  "number.format.precision": 3,
  "number.format.round_mode": "default",
  "number.format.separator": ".",
  "number.format.significant": false,
  "number.format.strip_insignificant_zeros": false,
  "number.human.decimal_units.format": "%n %u",
  "number.human.decimal_units.units.billion": "Billion",
  "number.human.decimal_units.units.million": "Million",
  "number.human.decimal_units.units.quadrillion": "Quadrillion",
  "number.human.decimal_units.units.thousand": "Thousand",
  "number.human.decimal_units.units.trillion": "Trillion",
  "number.human.decimal_units.units.unit": "",
  "number.human.format.delimiter": "",
  "number.human.format.precision": 3,
  "number.human.format.significant": true,
  "number.human.format.strip_insignificant_zeros": true,
  "number.human.storage_units.format": "%n %u",
  "number.human.storage_units.units.byte.one": "Byte",
  "number.human.storage_units.units.byte.other": "Bytes",
  "number.human.storage_units.units.eb": "EB",
  "number.human.storage_units.units.gb": "GB",
  "number.human.storage_units.units.kb": "KB",
  "number.human.storage_units.units.mb": "MB",
  "number.human.storage_units.units.pb": "PB",
  "number.human.storage_units.units.tb": "TB",
  "number.nth.ordinalized": {},
  "number.nth.ordinals": {},
  "number.percentage.format.delimiter": "",
  "number.percentage.format.format": "%n%",
  "number.precision.format.delimiter": "",
  "address.city": "City",
  "address.country": "Canada",
  "address.state": "Province",
  "address.zip": "Postal Code",
  "Wish List": "Wish List",
}
export default translations
